
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useCategories = () => {
  console.log("🔍 HOOK USE_CATEGORIES: Début de la requête");
  
  return useQuery({
    queryKey: ["categories"],
    queryFn: async () => {
      console.log("📥 REQUÊTE CATÉGORIES: Démarrage");
      
      // Requête pour obtenir toutes les catégories qui ont au moins un produit publié
      const { data, error } = await supabase
        .from('categories')
        .select(`
          id,
          name,
          product_categories!inner (
            product_id,
            products!inner (
              id,
              published
            )
          )
        `)
        .eq('product_categories.products.published', true)
        .order('name', { ascending: true });

      if (error) {
        console.error("❌ ERREUR RÉCUPÉRATION CATÉGORIES:", error);
        throw error;
      }

      console.log("🔎 DONNÉES BRUTES:", JSON.stringify(data, null, 2));
      
      // Créer un Set pour éviter les doublons
      const uniqueCategories = new Set<string>();
      
      // Parcourir les catégories et ajouter au Set uniquement celles avec des produits
      data.forEach(category => {
        if (category.product_categories && category.product_categories.length > 0) {
          uniqueCategories.add(category.name);
        }
      });
      
      // Convertir le Set en tableau et trier
      const validCategories = Array.from(uniqueCategories).sort();
      
      console.log("✅ CATÉGORIES FILTRÉES FINALES:", validCategories);
      console.log("✅ REQUÊTE CATÉGORIES: Terminée");
      
      return validCategories;
    },
    staleTime: 0, // Ne pas mettre en cache pour forcer le rafraîchissement
    refetchOnWindowFocus: true
  });
};
